




























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import TenantInitDataPO from "@/store/entities/basedata/tenantinitdatapo";
import buildTree from "@/lib/Common/buildtreehelper";


class PageDataInitRequest extends PageRequest {
  keyword: string;
  itemId: string;
  tenantId: number;
  parentId: number;
  isEnable: number = 1; //可使用
  areaId: number;
  modelId: number;
  systemDetailId: number = 0;
}
@Component({
  components: {},
})
export default class tenantData extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 1 }) tenantId: number;
  columns: any[] = [];
  datalist: any[] = [];
  loadinfo: boolean = false;
  initdataloading: boolean = false;

  pagerequest: PageDataInitRequest = new PageDataInitRequest();
  tenantInitData: TenantInitDataPO = new TenantInitDataPO();
  splitnum: number = 0.15;
  /**获取数据 */
  get list() {
    this.columns = [];
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        this.columns = this.itemcolumns;
        this.datalist = this.$store.state.menu.list;
        break;
      case 2: //采集器模型
        this.columns = this.collectorcolumns;
        this.datalist = this.$store.state.collectormodel.list;
        break;
      case 3: //表计模型
        this.columns = this.metercolumns;
        this.datalist = this.$store.state.metermodel.list;
        break;
      case 4: //表计参数
        this.columns = this.metermodelcolumns;
        this.datalist = this.$store.state.modelattribute.list;
        break;
      case 5: //城市
        this.columns = this.citycolumns;
        this.datalist = this.$store.state.city.list;
        break;
      case 6: //数据字典
        this.columns = this.dataItemcolumns;
        this.datalist = this.$store.state.itemdetail.list;
        break;
      case 7: //系统管理
        this.columns = this.systemcolumns;
        this.datalist = this.$store.state.channel.list;
        break;
      default:
        break;
    }
    return this.datalist;
  }
  get loading() {
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        this.loadinfo = this.$store.state.menu.loading;
        break;
      case 2: //采集器模型
        this.loadinfo = this.$store.state.collectormodel.loading;
        break;
      case 3: //表计模型
        this.loadinfo = this.$store.state.metermodel.loading;
        break;
      case 4: //表计参数
        this.loadinfo = this.$store.state.modelattribute.loading;
        break;
      case 5: //城市
        this.loadinfo = this.$store.state.city.loading;
        break;
      case 6: //数据字典
        this.loadinfo = this.$store.state.itemdetail.loading;
        break;
      case 7: //系统管理
        this.loadinfo = this.$store.state.channel.loading;
        break;
      default:
        break;
    }
    return this.loadinfo;
  }
  pageChange(page: number) {
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        this.$store.commit("menu/setCurrentPage", page);
        break;
      case 2: //采集器模型
        this.$store.commit("collectormodel/setCurrentPage", page);
        break;
      case 3: //表计模型
        this.$store.commit("metermodel/setCurrentPage", page);
        break;
      case 4: //表计参数
        this.$store.commit("modelattribute/setCurrentPage", page);
        break;
      case 5: //城市
        this.$store.commit("city/setCurrentPage", page);
        break;
      case 6: //数据字典
        this.$store.commit("itemdetail/setCurrentPage", page);
        break;
      case 7: //系统管理
        this.$store.commit("channel/setCurrentPage", page);
        break;
      default:
        break;
    }
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        this.$store.commit("menu/setPageSize", pagesize);
        break;
      case 2: //采集器模型
        this.$store.commit("collectormodel/setPageSize", pagesize);
        break;
      case 3: //表计模型
        this.$store.commit("metermodel/setPageSize", pagesize);
        break;
      case 4: //表计参数
        this.$store.commit("modelattribute/setPageSize", pagesize);
        break;
      case 5: //城市
        this.$store.commit("city/setPageSize", pagesize);
        break;
      case 6: //数据字典
        this.$store.commit("itemdetail/setPageSize", pagesize);
        break;
      case 7: //系统管理
        this.$store.commit("channel/setPageSize", pagesize);
        break;
      default:
        break;
    }
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        await this.$store.dispatch({
          type: "menu/getAll",
          data: this.pagerequest,
        });
        break;
      case 2: //采集器模型
        await this.$store.dispatch({
          type: "collectormodel/getAll",
          data: this.pagerequest,
        });
        break;
      case 3: //表计模型
        await this.$store.dispatch({
          type: "metermodel/getAll",
          data: this.pagerequest,
        });
        break;
      case 4: //表计参数
        await this.$store.dispatch({
          type: "modelattribute/getAll",
          data: this.pagerequest,
        });
        break;
      case 5: //城市
        await this.$store.dispatch({
          type: "city/getAll",
          data: this.pagerequest,
        });
        break;
      case 6: //数据字典
        await this.$store.dispatch({
          type: "itemdetail/getAll",
          data: this.pagerequest,
        });
        break;
      case 7: //系统管理
        await this.$store.dispatch({
          type: "channel/getAll",
          data: this.pagerequest,
        });
        break;
      default:
        break;
    }
  }
  get pageSize() {
    let pages = 10;
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        pages = this.$store.state.menu.pageSize;
        break;
      case 2: //采集器模型
        pages = this.$store.state.collectormodel.pageSize;
        break;
      case 3: //表计模型
        pages = this.$store.state.metermodel.pageSize;
        break;
      case 4: //表计参数
        pages = this.$store.state.modelattribute.pageSize;
        break;
      case 5: //城市
        pages = this.$store.state.city.pageSize;
        break;
      case 6: //数据字典
        pages = this.$store.state.itemdetail.pageSize;
        break;
      case 7: //系统管理
        pages = this.$store.state.channel.pageSize;
        break;
      default:
        break;
    }
    return pages;
  }
  get totalCount() {
    let total = 0;
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        total = this.$store.state.menu.totalCount;
        break;
      case 2: //采集器模型
        total = this.$store.state.collectormodel.totalCount;
        break;
      case 3: //表计模型
        total = this.$store.state.metermodel.totalCount;
        break;
      case 4: //表计参数
        total = this.$store.state.modelattribute.totalCount;
        break;
      case 5: //城市
        total = this.$store.state.city.totalCount;
        break;
      case 6: //数据字典
        total = this.$store.state.itemdetail.totalCount;
        break;
      case 7: //系统管理
        total = this.$store.state.channel.totalCount;
        break;
      default:
        break;
    }
    return total;
  }
  get currentPage() {
    let cp = 1;
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        cp = this.$store.state.menu.currentPage;
        break;
      case 2: //采集器模型
        cp = this.$store.state.collectormodel.currentPage;
        break;
      case 3: //表计模型
        cp = this.$store.state.metermodel.currentPage;
        break;
      case 4: //表计参数
        cp = this.$store.state.modelattribute.currentPage;
        break;
      case 5: //城市
        cp = this.$store.state.city.currentPage;
        break;
      case 6: //数据字典
        cp = this.$store.state.itemdetail.currentPage;
        break;
      case 7: //系统管理
        cp = this.$store.state.channel.currentPage;
        break;
      default:
        break;
    }
    return cp;
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.itemId = item[0].id;
    }
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        this.pagerequest.parentId = Number.parseInt(this.pagerequest.itemId);
        this.$store.commit("menu/setCurrentPage", 1);
        break;
      case 2: //采集器模型
        this.pagerequest.areaId = Number.parseInt(this.pagerequest.itemId);
        this.$store.commit("collectormodel/setCurrentPage", 1);
        break;
      case 3: //表计模型
        this.pagerequest.areaId = Number.parseInt(this.pagerequest.itemId);
        this.$store.commit("metermodel/setCurrentPage", 1);
        break;
      case 4: //表计参数
        this.pagerequest.modelId = Number.parseInt(this.pagerequest.itemId);
        this.$store.commit("modelattribute/setCurrentPage", 1);
        break;
      case 5: //城市
        this.pagerequest.parentId = Number.parseInt(this.pagerequest.itemId);
        this.$store.commit("city/setCurrentPage", 1);
        break;
      case 6: //数据字典
        this.pagerequest.parentId = Number.parseInt(this.pagerequest.itemId);
        this.$store.commit("itemdetail/setCurrentPage", 1);
        break;
      case 7: //系统管理
        this.pagerequest.systemDetailId = Number.parseInt(this.pagerequest.itemId);
        this.$store.commit("channel/setCurrentPage", 1);
        break;
      default:
        break;
    }
    this.getpage();
  }
  //城市列
  citycolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: this.L("Name"),
      key: "fullName",
      width: 180,
      tree: true,
    },
    {
      title: this.L("Encode"),
      key: "encode",
      width: 130,
    },
    {
      title: this.L("SimpleSpelling"),
      key: "simpleSpelling",
      width: 180,
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
    },
    {
      title: this.L("IsEnable"),
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Id"),
      key: "id",
      width: 130,
    },
  ];
  //采集器列
  collectorcolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 160,
      fixed: "left",
    },
    {
      title: this.L("Device") + this.L("Category"),
      key: "deviceTypeId",
      width: 160,
      render: (h: any, params: any) => {
        let id = params.row.deviceTypeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("ISP"),
      key: "isp",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: "AppId",
      key: "appId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appId },
            },
            params.row.appId
          ),
        ]);
      },
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.appSecret },
            },
            params.row.appSecret
          ),
        ]);
      },
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Tenants") + "Id",
      key: "tenantId",
      width: 130,
    },
    {
      title: this.L("Product") + "Id",
      key: "productId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.productId },
            },
            params.row.productId
          ),
        ]);
      },
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.masterId },
            },
            params.row.masterId
          ),
        ]);
      },
    },
    {
      title: this.L("Manufacturer") + "Id",
      key: "manufacturerId",
      width: 130,
    },
    {
      title: this.L("Manufacturer") + this.L("Name"),
      key: "manufacturerName",
      width: 130,
    },
    {
      title: this.L("Device") + this.L("Model"),
      key: "deviceModel",
      width: 130,
    },
    {
      title: this.L("Object") + "Id",
      key: "obj_Id",
      width: 130,
    },
    {
      title: this.L("Inst") + "Id",
      key: "obj_Inst_id",
      width: 130,
    },
    {
      title: this.L("Resource") + "Id",
      key: "res_Id",
      width: 130,
    },
    {
      title: this.L("IsActive"),
      key: "isEnable",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.description },
            },
            params.row.description
          ),
        ]);
      },
    },
  ];
  //菜单列
  itemcolumns = [
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: this.L("MenuTag"),
      key: "tagName",
      width: 230,
      tree: true,
      fixed: "left",
    },
    {
      title: this.L("Name"),
      key: "displayName",
      width: 130,
      fixed: "left",
    },
    {
      title: this.L("Category"),
      key: "menuType",
      width: 130,
      render: (h: any, params: any) => {
        let str = this.L("Unknown");
        let id = params.row.menuType;
        if (id == 1) {
          str = this.L("ParentMenu");
        } else if (id == 2) {
          str = this.L("ParentGroup");
        } else if (id == 3) {
          str = this.L("Menu");
        }
        return h("span", str);
      },
    },
    {
      title: this.L("Path"),
      key: "path",
      width: 180,
    },
    {
      title: this.L("Icon"),
      key: "icon",
      width: 180,
    },
    {
      title: this.L("Action"),
      key: "action",
      width: 180,
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
    },
    {
      title: this.L("IsEnable"),
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Description"),
      key: "remark",
      width: 180,
    },
  ];
  //表计模型
  metercolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        //console.log(info)
        return h(
          "span",
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 130,
      fixed: "left",
      sortable: true,
    },
    {
      title: this.L("Transfer") + this.L("Category"),
      key: "transferType",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.transferType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Meter") + this.L("Category"),
      key: "meterType",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.meterType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("DeviceType"),
      key: "deviceType",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.deviceType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Application") + this.L("Category"),
      key: "applicationId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.applicationId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("ISP"),
      key: "isp",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Level"),
      key: "levelId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.levelId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Supplier"),
      key: "supplierId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.supplierId;
        let ite = JSON.parse(localStorage.getItem("suppliers"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Magnification"),
      key: "magnification",
      width: 130,
    },
    {
      title: this.L("OnOff"),
      key: "isOnOff",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isOnOff == true ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("IsSec"),
      key: "isSec",
      width: 90,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isSec == true ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("AesKey"),
      key: "aesKey",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.aesKey,
            },
          },
          params.row.aesKey
        );
      },
    },
    {
      title: this.L("Controle") + this.L("Category"),
      key: "controleType",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.controleType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Price"),
      key: "priceId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.priceId;
        let ite = JSON.parse(localStorage.getItem("prices"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("BoxNum"),
      key: "boxNum",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.boxNum,
            },
          },
          params.row.boxNum
        );
      },
    },
    {
      title: "AppId",
      key: "appId",
      width: 130,
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Tenants") + "Id",
      key: "tenantId",
      width: 130,
    },
    {
      title: this.L("Product") + "Id",
      key: "productId",
      width: 130,
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.masterId,
            },
          },
          params.row.masterId
        );
      },
    },
    {
      title: this.L("Manufacturer") + "Id",
      key: "manufacturerId",
      width: 130,
    },
    {
      title: this.L("Manufacturer") + this.L("Name"),
      key: "manufacturerName",
      width: 130,
    },
    {
      title: this.L("Device") + this.L("Model"),
      key: "deviceModel",
      width: 130,
    },
    {
      title: this.L("Object") + "Id",
      key: "obj_Id",
      width: 130,
    },
    {
      title: this.L("Inst") + "Id",
      key: "obj_Inst_id",
      width: 130,
    },
    {
      title: this.L("Resource") + "Id",
      key: "res_Id",
      width: 130,
    },
    {
      title: this.L("IsActive"),
      key: "isEnable",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
    },
  ];
  //表计参数列
  metermodelcolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("ModelInfo"),
      key: "modelId",
      width: 130,
      sortable: true,
    },
    {
      sortable: true,
      title: this.L("Name"),
      key: "name",
      width: 130,
      fixed: "left",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.name },
            },
            params.row.name
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("Params"),
      key: "paramsId",
      width: 90,
      render: (h: any, params: any) => {
        let id = params.row.paramsId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      sortable: true,
      title: this.L("Encode"),
      key: "code",
      width: 90,
    },
    {
      sortable: true,
      title: this.L("Controle") + this.L("Encode"),
      key: "controlCode",
      width: 130,
    },
    {
      sortable: true,
      title: this.L("Address"),
      key: "address",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.address,
            },
          },
          params.row.address
        );
      },
    },
    {
      title: this.L("Start"),
      key: "startBit",
      width: 90,
    },
    {
      title: this.L("Length"),
      key: "length",
      width: 90,
    },
    {
      title: this.L("Protocol"),
      key: "protocolId",
      width: 90,
      render: (h: any, params: any) => {
        let id = params.row.protocolId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: { title: info.length > 0 ? info[0].name : "未知" },
          },
          info.length > 0 ? info[0].name : "未知"
        );
      },
    },
    {
      title: this.L("Field") + this.L("Name"),
      key: "fieldName",
      width: 130,
    },
    {
      title: this.L("Field") + this.L("Category"),
      key: "fieldType",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.fieldType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      sortable: true,
      title: this.L("Ratio"),
      key: "ratio",
      width: 90,
    },
    {
      sortable: true,
      title: this.L("IsActive"),
      key: "isEnable",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 90,
      sortable: true, //开启排序
      sortType: "asc", //初始化排序
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 90,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.description },
            },
            params.row.description
          ),
        ]);
      },
    },
  ];
  //数字字典
  dataItemcolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: this.L("Name"),
      width: 180,
      key: "name",
      sortable: true,
    },
    {
      title: this.L("FirstNode"),
      key: "itemName",
      width: 180,
      sortable: true,
    },
    {
      title: this.L("Encode"),
      key: "enCode",
      width: 180,
      sortable: true,
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 80,
      sortable: true,
    },
    {
      title: this.L("IsEnable"),
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Id"),
      key: "id",
      sortable: true,
    },
  ];
  /**系统列表 */
  systemcolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      align: "center",
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 180,
      tree: true,
    },
    {
      title: this.L("SystemDetail"),
      key: "systemName",
      width: 130,
    },
    {
      title: this.L("Color"),
      key: "color",
      width: 130,
    },
    {
      title: this.L("ImageUrl"),
      key: "imageUrl",
      width: 180,
    },
    {
      title: this.L("LanguageTag"),
      key: "languageTag",
      width: 130,
    },
    {
      title: this.L("IsEnable"),
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
    },
    {
      title: this.L("Id"),
      key: "id",
      width: 130,
    },
  ];
  /**保存数据 */
  async save() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    this.tenantInitData.targetId = [];
    this.tenantInitData.tenantId = this.tenantId;
    val.forEach((ele) => {
      this.tenantInitData.targetId.push(ele.id);
    });
    this.initdataloading = true;
    let res = await this.$store
      .dispatch({
        type: "tenant/initData",
        data: this.tenantInitData,
      })
      .catch(() => {
        this.initdataloading = false;
      });
    console.log(res);
    this.$Modal.info({
      title: this.L("Tips"),
      content: res.data.result,
    });
    this.initdataloading = false;
  }
  //搜索数据
  getSearch() {
    switch (this.tenantInitData.typeId) {
      case 1: //菜单
        this.pagerequest.itemId = "0";
        this.itemtree();
        break;
      case 2: //采集器模型
        this.pagerequest.areaId = 0;
        this.getAreaTree();
        break;
      case 3: //表计模型
        this.getAreaTree();
        this.pagerequest.areaId = 0;
        break;
      case 4: //表计参数
        this.pagerequest.modelId = 0;
        this.getmodeltree();
        break;
      case 5: //城市
        this.citytree();
        break;
      case 6: //数据字典
        this.dataitemtree();
        break;
      case 7: //系统管理
        this.systemtree();
        break;
      default:
        break;
    }
    this.getpage();
  }
  /**菜单左边 */
  async itemtree() {
    await this.$store
      .dispatch("menu/getFirstNodeSelectTree")
      .then((val) => {
        this.$data.treedata = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  /**采集器/表计模型左边 */
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.$data.treedata = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  /**表计模型 */
  async getmodeltree() {
    this.$data.treedata = [];
    await this.$store
      .dispatch("metermodel/getalllist")
      .then((val) => {
        val.forEach((ele) => {
          this.$data.treedata.push({
            id: ele.id,
            title: ele.name,
            expand: true,
          });
        });
      })
      .catch((err) => {
        //return null;
      });
  }
  /**城市 */
  async citytree() {
    await this.$store
      .dispatch("city/getFirstNodeTree")
      .then((val) => {
        this.$data.treedata = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  /**数据字典 */
  async dataitemtree() {
    await this.$store
      .dispatch("items/getTree")
      .then((val) => {
        console.log(val)
        this.$data.treedata = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  /**系统管理类型 */
  systemtree() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    let list = detaillist.filter((ele) => {
      return ele.itemId == 29;
    })

    this.$data.treedata = [];
    list.forEach((ele) => {
      this.$data.treedata.push({ title: ele.name, id: ele.id, extends: true });

    });
    console.log(this.$data.treedata)
  }
  data() {
    return {
      treedata: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  //租户id
  @Watch("tenantId")
  getitemId() {
    this.pagerequest.tenantId = this.tenantId;
  }
}
